<template>
  <div class="editableInput" @click="handleTextClick">
    <template v-if="editing">
      <!--进入编辑状态-->
      <component :is="component" border class="editableInputInput" v-model="tmpValue" :selectList="selectList" :radioList="radioList"></component>
    </template>
      <!--查看的状态-->
    <template v-else>
      <!--根据传入的组件名,展示出不同的图标-->
      <template v-if="component === 'color-picker-component'">
        <span :style="{'color': this.value}">{{value}}</span>
        <el-icon :style="{'color': this.value}" name="star-on"></el-icon>
      </template>
      <template v-if="component === 'radio-component'">
        <span >{{value}}</span>
        <el-icon name="checkmark-circle" :style="{'color': '#4e81bb'}"></el-icon>
      </template>
      <template v-if="component === 'select-component'">
        <span >{{value}}</span>
        <el-icon name="list" :style="{'color': '#4e81bb'}"></el-icon>
      </template>
      <template v-if="component === 'el-switch'">
        <span>{{value}}</span>
        <el-icon name="checkmark-circle" :style="{'color': '#4e81bb'}" v-if="value === true"></el-icon>
        <el-icon name="close-circle" :style="{'color': '#4e81bb'}" v-if="value === false"></el-icon>
      </template>
      <!--未编辑状态的输入框-->
      <template v-if="component === 'el-input'">
        <!--展示出设置的值-->
        <span>{{value}}</span>
        <!--图标显示笔的形状-->
        <el-icon name="edit" :style="{'color': '#4e81bb'}"></el-icon>
      </template>
    </template>
  </div>
</template>

<script>
import SelectComponent from "./SelectComponent";
import RadioComponent from "./RadioComponent"
import ColorPickerComponent from "./ColorPickerComponent"
export default {
  name: "EditableInput",      // 可以编辑的输入框组件,会根据要编辑的属性类型,展示出不同的输入框,可能是颜色框、输入框、选择框
  props: {
    value: {},
    component: String,     // 接收要展示的组件信息
    selectList: Array,
    radioList: Array,
  },
  components:{SelectComponent, RadioComponent, ColorPickerComponent},    // 注册要用的自定义组件
  data() {
    return {
      editing: false,      // 是否在编辑
      tmpValue: undefined,  // 当前输入的临时值
    }
  },
  methods: {
    handleTextClick() {    // 点击展示框,即要输入内容了
      if(this.editing) {
        return
      }
      this.editing = true           // 把编辑状态改成true,展示出真正的输入框
      this.tmpValue = this.value    // 用父组件的值展示在编辑框上
      let func = (e) => {     // 设置一个回调事件,当点击的不是当前的输入框,那就更新值,变成预览模式
        // 特殊情况,颜色选择的时候会点到选择颜色的组件中,特判一下
        let str = undefined
        if (e.path.length > 1 && e.path[0]._prevClass === undefined && e.path[1]._prevClass !== undefined) {  // 点颜色确认时的处理
          str = e.path[1]._prevClass
        }
        else if (e.path.length > 0 && e.path[0]._prevClass !== undefined ){
          str = e.path[0]._prevClass
        }
        if (str !== undefined && str.indexOf("el-color") !== -1) return
        //console.log("e.path",e.path)
        // 不是当前编辑框元素
        if(e.path.indexOf(this.$el) === -1) {
          this.$emit('input', this.tmpValue)
          this.editing = false
          document.removeEventListener('click', func, true)
        }
      }
      document.addEventListener('click', func, true)   // 全局添加一个点击事件
    },
  },
}
</script>

<style lang="less" scoped>
  .editableInput {
    .editableInputInput{
    }
  }
</style>